module.exports = __webpack_public_path__ + "fonts/Eurostile-Bold.eot";


//////////////////
// WEBPACK FOOTER
// ./fonts/Eurostile-Bold.eot
// module id = 31
// module chunks = 0